import { Box, Grid, Typography } from '@mui/material';
import { DetailRow } from './DetailRow';

interface ProductDetailsData {
	productName?: string | null;
	publisher?: string | null;
	purchaseType?: string | null;
	vendor?: string | null;
	vendorContact?: string | null;
	applicationOwner?: string | null;
	managedBy?: string | null;
	cloudOnPrem?: string | null;
	billingCycle?: string | null;
	licenseModel?: string | null;
	licenseQuantity?: string | number | null;
}

interface ProductDetailsCardProps {
	data: ProductDetailsData | null;
}

const ProductDetailsCard = ({ data }: ProductDetailsCardProps) => {
	if (!data) return null;

	const leftColumnFields = [
		{ label: 'Product Name', value: data.productName },
		{ label: 'Publisher', value: data.publisher },
		{ label: 'Purchase Type', value: data.purchaseType },
		{ label: 'Vendor', value: data.vendor },
		{ label: 'Vendor Contact', value: data.vendorContact },
		{ label: 'Application Owner', value: data.applicationOwner }
	];

	const rightColumnFields = [
		{ label: 'Managed By', value: data.managedBy },
		{ label: 'Type', value: data.cloudOnPrem },
		{ label: 'Billing Cycle', value: data.billingCycle },
		{ label: 'License Type', value: data.licenseModel },
		{ label: 'Total Licenses', value: typeof data.licenseQuantity === 'number' ? data.licenseQuantity : '-' },
		{ label: 'Active Vs Inactive Licenses', value: "-" }
	];

	return (
		<Box
			sx={{
				background: '#ffffff',
				borderRadius: '8px',
				p: 3,
				height: 'calc(100% - 48px)'
			}}
		>
			<Typography
				sx={{
					fontSize: '18px',
					fontWeight: 700,
					color: '#1b1f23',
					mb: 2,
					pb: 1,
				}}
			>
				Product Details
			</Typography>
			<Grid container spacing={3}>
				<Grid item xs={12} md={6}>
					{leftColumnFields.map((field) => (
						<DetailRow key={field.label} label={field.label} value={field.value} />
					))}
				</Grid>
				<Grid item xs={12} md={6}>
					{rightColumnFields.map((field) => (
						<DetailRow key={field.label} label={field.label} value={field.value} />
					))}
				</Grid>
			</Grid>
		</Box>
	);
};

export default ProductDetailsCard;
